import React, { useState, useEffect } from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { TSignalCountsOnSpeedRangesItem } from '../../kpiTypes';
import { formatValueAsString } from '../../../../utils/helpers';
import { ChartContainer } from '../../../../shared/components/charts/ChartContainer';

export interface ISpeedDistributionChartProps {
	chartKey: number;
	signalCountsOnSpeedRangesData: TSignalCountsOnSpeedRangesItem[];
}

const SpeedDistributionChart: React.FC<ISpeedDistributionChartProps> = ({ ...props }) => {
	const formatOptions: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 2 };

	const [options, setOptions] = useState<AgChartOptions>({
		title: {
			enabled: false,
			text: 'Speed Distribution',
			textAlign: 'left',
		},

		data: Array.isArray(props.signalCountsOnSpeedRangesData) ? props.signalCountsOnSpeedRangesData : [],
		series: [
			{
				type: 'bar',
				xKey: 'rangeLevel',
				yKey: 'countOfSpeedRange',
				yName: 'Speed Range',
				fill: '#183d57',
				stroke: 'white',
				strokeWidth: 1,
				tooltip: {
					renderer: (params) => {
						return {
							data: undefined,
							title: 'Speed Range',
							heading: `${params.datum.rangeLevel}:  ${formatValueAsString(params.datum.countOfSpeedRange, formatOptions, '', '', '')}`,
						};
					},
				},
			},
		],
		axes: [
			{
				type: 'number',
				title: {
					text: '#Hours',
				},
				label: {
					formatter: (params) => {
						return formatValueAsString(params.value, formatOptions, '', '', '');
					},
				},
				nice: false,
			},
			{
				type: 'number',
				gridLine: {
					style: [
						{
							stroke: 'lightgray',
							lineDash: [1, 3],
						},
					],
				},
				title: {
					enabled: false,
					text: 'Speed (knots)',
				},
				nice: false,
			},
		],
	});

	// Update chart data when props change
	useEffect(() => {
		const newData = Array.isArray(props.signalCountsOnSpeedRangesData) ? props.signalCountsOnSpeedRangesData : [];
		setOptions(prevOptions => ({
			...prevOptions,
			data: newData
		}));
	}, [props.signalCountsOnSpeedRangesData]);

	return (
		<ChartContainer
			data={options.data}
			filename="speed_distribution_chart"
			buttonPosition="top-right"
		>
			<AgCharts key={props.chartKey} options={options} className="w-full h-full pt-1" />
		</ChartContainer>
	);
};

export default SpeedDistributionChart;
